import React from 'react';
import { IconProps } from '.';

const SvgPictureX = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M22.75 3.25H1.25v17.5h12.568v-1.5H7.747l7.767-8.176 2.456 2.456 1.06-1.06-3.544-3.544L5.678 19.25H2.75V4.75h18.5v8.139h1.5V3.25Z'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='M7 6.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5ZM5.75 9a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z'
        clipRule='evenodd'
      />
      <path
        fill={color}
        d='M16.47 16.53 18.94 19l-2.47 2.47 1.06 1.06L20 20.06l2.47 2.47 1.06-1.06L21.06 19l2.47-2.47-1.06-1.06L20 17.94l-2.47-2.47-1.06 1.06Z'
      />
    </svg>
  );
};

export default SvgPictureX;
